"use strict"; // TODO: Remove from @thesisedu/web

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.omitDeep = void 0;

var omitDeep = function omitDeep(input, excludeKeys) {
  if (Array.isArray(input)) {
    return input.map(function (item) {
      return (0, exports.omitDeep)(item, excludeKeys);
    });
  } else if (typeof input === 'object' && input) {
    var newResult = {};

    for (var _i = 0, _Object$keys = Object.keys(input); _i < _Object$keys.length; _i++) {
      var key = _Object$keys[_i];

      if (!excludeKeys.includes(key)) {
        newResult[key] = (0, exports.omitDeep)(input[key], excludeKeys);
      }
    }

    return newResult;
  } else {
    return input;
  }
};

exports.omitDeep = omitDeep;